module.exports = __webpack_public_path__ + "img/ic_publicity_detail9_1.dad16311.jpg";